import angular from 'angular';
import homeComponent from './home.component';
import HomeService from './home.service';
import homeConfig from './home.config';
import BrandsModule from './brands/brands';
import MenuModule from './menu/menu';
import SlidersModule from './sliders/sliders';

import CarouselCategoryModule from './carousel-category/carousel-category';
import FeaturedSliderModule from './featured-slider/featured-slider';

let homeModule = angular.module('home', [
        BrandsModule.name,
        MenuModule.name,
        SlidersModule.name,
        CarouselCategoryModule.name,
        FeaturedSliderModule.name])
    .component('home', homeComponent)
    .service('HomeService', HomeService)
    .config(homeConfig);

export default homeModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/home.js
 **/